import { ClipboardList, Download, Info, XCircle } from "lucide-react";
import { useState } from "react";
import { useSelector } from "react-redux";
import * as S from "../dashboard/_shared";
import PeriodPillBig from "../periodPillBig";
import Tag from "../tag";
import "./style.scss";

export default function PDFExportModal({ onClose, onGenerate, currentPeriod }) {
  const { C } = S;
  const periods = useSelector((state) => state.dashboard.periods?.data?.data || []);
  const respondents = useSelector((state) => state.dashboard.overview?.data?.data?.[0]?.respondents ?? 0);
  const ALL_PAGES = [
    { id: "executivo", label: "Visão Geral" },
    { id: "jornada", label: "Jornada" },
    { id: "drivers", label: "Drivers" },
    { id: "tendencias", label: "Tendências" },
    { id: "segmentos_nps", label: "Segmentação NPS" },
    { id: "segmentos_csat", label: "Segmentação CSAT" },
    { id: "segmentos_ces", label: "Segmentação CES" },
    { id: "benchmark", label: "Benchmarking" },
    { id: "acoes", label: "Plano de Ação" },
    { id: "quest", label: "Metodologia" },
  ];
  const [selected, setSelected] = useState(
    ALL_PAGES.reduce((acc, p) => ({ ...acc, [p.id]: true }), {}),
  );
  const [periodo, setPeriodo] = useState(currentPeriod || "trimestral");
  const [customRange, setCustomRange] = useState({ inicio: "", fim: "" });
  const totalSelected = Object.values(selected).filter(Boolean).length;
  function toggleAll(v) {
    setSelected(ALL_PAGES.reduce((acc, p) => ({ ...acc, [p.id]: v }), {}));
  }
  return (
    <div className="compPdfExportModal">
      <div className="dialog">
        <div className="dialogHeader">
          <div className="headerLeft">
            <div className="headerIcon">
              <Download size={18} color="#FFFFFF" />
            </div>
            <div>
              <h3 className="dialogTitle">Exportar PDF</h3>
              <div className="dialogSubtitle">
                Escolha o conteúdo e o período do relatório
              </div>
            </div>
          </div>
          <button onClick={onClose} className="closeBtn">
            <XCircle size={20} />
          </button>
        </div>

        <div className="dialogBody">
          <div className="sectionLabel">1. Páginas para incluir</div>
          <div className="toggleRow">
            <button onClick={() => toggleAll(true)} className="toggleBtn">
              Marcar todas
            </button>
            <button onClick={() => toggleAll(false)} className="toggleBtn">
              Desmarcar
            </button>
            <div className="toggleSpacer" />
            <Tag
              label={`${totalSelected}/${ALL_PAGES.length} selecionadas`}
              color={C.g700}
            />
          </div>
          <div className="pagesGrid">
            {ALL_PAGES.map((p) => (
              <label
                key={p.id}
                className={`pageLabel ${selected[p.id] ? "is-selected" : "is-unselected"}`}
              >
                <input
                  type="checkbox"
                  checked={selected[p.id]}
                  onChange={(e) =>
                    setSelected({ ...selected, [p.id]: e.target.checked })
                  }
                  className="pageCheckbox"
                  style={{ '--checkbox-accent': C.g700 }}
                />
                <span
                  className={`pageLabelText ${selected[p.id] ? "is-selected" : "is-unselected"}`}
                >
                  {p.label}
                </span>
                {p.id === "acoes" && (
                  <span className="alwaysCurrentBadge">SEMPRE ATUAL</span>
                )}
              </label>
            ))}
          </div>

          <div className="sectionLabel is-second">2. Período do relatório</div>
          <div className="infoBanner">
            <span className="infoIcon">
              <Info size={13} color={C.p600} />
            </span>
            <div className="infoText">
              O <b>Plano de Ação</b> reflete sempre o estado atual das ações em
              andamento na plataforma — não é segmentado por período. Todas as
              outras páginas usam o período selecionado abaixo.
            </div>
          </div>
          <div className="periodBox">
            <PeriodPillBig
              value={periodo}
              onChange={setPeriodo}
              custom={customRange}
              onCustomChange={setCustomRange}
            />
            {(() => {
              const selectedPeriod = periods.find((p) => p.name === periodo);
              if (!selectedPeriod) return null;
              // O total carregado é o do período da tela; para outro período
              // ele só é conhecido depois que o PDF recarrega os dados.
              const isCurrentPeriod = selectedPeriod.name === currentPeriod;
              return (
                <div className="periodSummary">
                  <ClipboardList size={12} color={C.text4} />
                  <span>
                    <b>{selectedPeriod.name}</b>
                    {isCurrentPeriod && (
                      <>
                        {" "}
                        · {respondents.toLocaleString()} respondentes neste
                        período
                      </>
                    )}
                  </span>
                </div>
              );
            })()}
          </div>
        </div>

        <div className="dialogFooter">
          <button onClick={onClose} className="cancelBtn">
            Cancelar
          </button>
          <button
            onClick={() =>
              onGenerate({
                pages: Object.keys(selected).filter((k) => selected[k]),
                periodo,
                customRange,
              })
            }
            disabled={
              totalSelected === 0 ||
              (periodo === "custom" &&
                (!customRange.inicio || !customRange.fim))
            }
            className={`generateBtn ${totalSelected > 0 ? "is-enabled" : "is-disabled"}`}
          >
            <Download size={13} /> Gerar PDF
          </button>
        </div>
      </div>
    </div>
  );
}
